// Each row is assigned to exactly one of these categories. Filter chips
// on the page toggle which categories are visible. Default: actionable
// buckets on, already-cleared buckets off.
export const FILTER_CATEGORIES = [
  { id: 'variance',  label: 'Variance' },
  { id: 'expected_cancel', label: 'Expected cancel' },
  { id: 'missing',   label: 'Missing in a source' },
  { id: 'reviewed',  label: 'Reviewed' },
  { id: 'match',     label: 'Matches' },
];

export const DEFAULT_ACTIVE_FILTERS = new Set(['variance', 'missing']);

// GM ↔ CPQ alignment is the cycle goal — matches win first, regardless of
// whether an inherited review from a prior round is attached.
export const categorizeRow = (r) => {
  if (!r) return 'match';
  const gmCpqAbs = Math.abs(r.deltas?.gmVsCpq || 0);
  if (gmCpqAbs <= 1) return 'match';
  const driver = String(r.review?.category || r.reviewDriver || r.autoDriver || r.auto_driver || '').toUpperCase();
  if (driver === 'EXPECTED_CANCEL') return 'expected_cancel';
  if (r.review?.reviewed) return 'reviewed';
  if (typeof r.status === 'string' && r.status.startsWith('missing')) return 'missing';
  return 'variance';
};
